module.exports = __webpack_public_path__ + "static/DNAnudge-8f2a9971d109511367f4d7cc8d2ad96a.png";